import { DomainEntity } from '../shared';
import { getDisplayValue } from './helpers/get-display-value';
import { isEdited } from './helpers/is-edited';
import { nullUser } from './null-user';
import { UserDetail } from './types/user-detail.type';

export class User extends DomainEntity<UserDetail> {
    constructor(user: UserDetail) {
        super(user);
    }

    public createDefault() {
        return new User(nullUser as any) as this;
    }

    get userId() {
        return {
            value: getDisplayValue(this.dto.userId, this.dto.pendingUser.userId.toString()),
            edited: isEdited(this.dto.userId, this.dto.pendingUser.userId.toString()),
        };
    }

    get name() {
        return {
            value: getDisplayValue(this.dto.name, this.dto.pendingUser.name),
            edited: isEdited(this.dto.name, this.dto.pendingUser.name),
        };
    }

    get userName() {
        return {
            value: this.dto.userName,
            edited: false,
        };
    }

    get status() {
        return {
            value: this.dto.status,
            edited: false,
        };
    }

    get isLocked() {
        return {
            value: this.dto.isLocked,
            edited: false,
        };
    }

    get isMfaLocked() {
        return {
            value: this.dto.isMfaLocked,
            edited: false,
        };
    }

    get isAdmin() {
        return {
            value: getDisplayValue(this.dto.isAdmin, this.dto.pendingUser.isAdmin),
            edited: isEdited(this.dto.isAdmin, this.dto.pendingUser.isAdmin),
        };
    }

    get isSuperUser() {
        return {
            value: getDisplayValue(this.dto.isSuperUser, this.dto.pendingUser.isSuperUser),
            edited: isEdited(this.dto.isSuperUser, this.dto.pendingUser.isSuperUser),
        };
    }

    get email() {
        return {
            value: getDisplayValue(this.dto.email, this.dto.pendingUser.email),
            edited: isEdited(this.dto.email, this.dto.pendingUser.email),
        };
    }

    get phone() {
        return {
            value: getDisplayValue(this.dto.phone, this.dto.pendingUser.phone) as string,
            edited: isEdited(this.dto.phone, this.dto.pendingUser.phone),
        };
    }

    get extension() {
        return {
            value: getDisplayValue(this.dto.extension, this.dto.pendingUser.extension),
            edited: isEdited(this.dto.extension, this.dto.pendingUser.extension),
        };
    }

    get mobile() {
        return {
            value: getDisplayValue(this.dto.mobile, this.dto.pendingUser.mobile),
            edited: isEdited(this.dto.mobile, this.dto.pendingUser.mobile),
        };
    }

    get mobileExtension() {
        return {
            value: getDisplayValue(this.dto.mobileExtension, this.dto.pendingUser.mobileExtension),
            edited: isEdited(this.dto.mobileExtension, this.dto.pendingUser.mobileExtension),
        };
    }

    get phoneCarrier() {
        return {
            value: this.dto.phoneCarrier,
            edited: false,
        };
    }

    get department() {
        return {
            value: getDisplayValue(this.dto.department, this.dto.pendingUser.department),
            edited: isEdited(this.dto.department, this.dto.pendingUser.department),
        };
    }

    get fax() {
        return {
            value: getDisplayValue(this.dto.fax, this.dto.pendingUser.fax),
            edited: isEdited(this.dto.fax, this.dto.pendingUser.fax),
        };
    }

    get pendingState() {
        return this.dto.pendingState;
    }

    get completedApprovals() {
        return this.dto.completedApprovals;
    }

    get loginId() {
        return {
            value: getDisplayValue(this.dto.loginId, this.dto.pendingUser.loginId),
            edited: isEdited(this.dto.loginId, this.dto.pendingUser.loginId),
        };
    }

    get isEnrolled() {
        return this.dto.isEnrolled;
    }

    get userProductFeatures() {
        return this.dto.userProductFeatures;
    }

    get isEditor() {
        return this.dto.isEditor;
    }

    get editedByUserName() {
        return this.dto.editedByUser.name;
    }
}
